export const CHANGE_USER_LOGIN_STATUS = 'change_user_login_status';
export const GET_USER_PRIME_STATUS = 'get_user_prime_status';
export const CHANGE_USER_PRIME_DATA = 'change_user_prime_data';
export const SHOW_AUTH_MODAL = 'show_auth_modal';
export const STORE_USER_DATA = 'store_user_data';
export const STORE_WALLET_DATA = 'store_wallet_data';
export const CHANGE_SERUM_COUNT = 'change_serum_count';
export const CHANGE_CASH_COUNT = 'change_cash_count';

// MedPass Constants
export const CHANGE_MEDPASS_LIST = 'change_medpass_list';
export const CHANGE_SUBSCRIPTION_POPUP_VISIBILITY = 'change_subscription_popup_visibility';
export const CHANGE_MEDPASS_POPUP_VISIBILITY = 'change_medpass_popup_visibility';
export const CHANGE_SUB_MEDPASS_POPUP_VISIBILITY = 'change_sub_medpass_popup_visibility';
// Comments constants
export const CHANGE_COMMENT_COUNT = 'change_comment_count';
export const CHANGE_COMMENTS_DATA = 'change_comments_data';
export const CHANGE_MORE_COMMENTS_DATA = 'change_more_comments_data';
export const CHANGE_COMMENT_FIELD = 'change_comment_field';
export const CHANGE_COMMENT_SUBMIT_STATUS = 'change_comment_submit_status';
export const HANDLE_ADD_COMMENT = 'handle_add_comment';
export const READY_TO_UPDATE_COMMENT = 'ready_to_update_comment';
export const CANCEL_UPDATE_COMMENT = 'cancel_update_comment';
export const HANDLE_UPDATE_COMMENT = 'handle_update_comment';
export const HANDLE_UPDATE_INNER_COMMENT = 'handle_update_inner_comment';
export const READY_TO_REPLY_COMMENT = 'ready_to_reply_comment';
export const CANCEL_REPLAY_TO_COMMENT = 'cancel_reply_to_comment';
export const HANDLE_REPLY_TO_COMMENT = 'handle_reply_to_comment';
export const HANDLE_GET_COMMENT_REPLIES = 'handle_get_comment_replies';
export const HANDLE_DELETE_COMMENT = 'handle_delete_comment';
export const HANDLE_DELETE_INNER_COMMENT = 'handle_delete_inner_comment';

/* Testimonials constants */
export const CHANGE_TESTIMONIALS_DATA = 'change_testimonials_data';
